import React from 'react';

const AdjectiveSize = () => {
  return (
    <div className="gadject-container">
      <div className="gadject-head">Adjectives of shape and size:</div>

      <div className="shape-container">
        <div className="shape">
          <div className="table1">
            <p>big</p>
            <p>small</p>
            <p>long</p>
            <p>short</p>
            <p>narrow</p>
            <p>wide</p>
            <p>thick</p>
            <p>thin</p>
          </div>

          <div className="table1">
            <p>ńlá</p>
            <p>kékeré</p>
            <p>gùn</p>
            <p>kúkúrú</p>
            <p>híhá</p>
            <p>gbòòrò</p>
            <p>nípọn</p>
            <p>títírín</p>
          </div>
        </div>

        <div className="shape">
          <div className="table1">
            <p>heavy</p>
            <p>light</p>
            <p>old</p>
            <p>young</p>
            <p>tall</p>
            <p>round</p>
            <p>fat</p>
            <p>smooth</p>
          </div>

          <div className="table1">
            <p>wúwo</p>
            <p>fẹlẹfẹlẹ</p>
            <p>arúgbó</p>
            <p>ọ̀dọ́</p>
            <p>ga</p>
            <p>róbótó</p>
            <p>sanra</p>
            <p>dídán</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdjectiveSize;
